import React from 'react';
import { InfoList } from 'components/infoList';
import { InfoRow } from 'components/infoRow';
import { ReviewCompletedProfiledTabProps } from 'containers/selfOnboarding/steps/types';
import { useFlags } from 'featureFlags';
import { getInfoRows } from './utils';

export function ReviewCompletedProfileWorkerInfoTab(
  props: ReviewCompletedProfiledTabProps,
): React.ReactElement {
  const { state, loading, navigation, localize, jobsiteInvitation } = props;
  const { goToStep } = navigation;
  const { authenticatedSelfOnboardingEnabled } = useFlags();

  const infoRows = React.useMemo(
    () =>
      getInfoRows({
        state,
        localize,
        jobsiteInvitation,
        authenticatedSelfOnboardingEnabled,
      }),
    [state, localize, jobsiteInvitation, authenticatedSelfOnboardingEnabled],
  );

  return (
    <div className="odin-flex odin-gap-x-10">
      <InfoList withBottomBorder loading={loading}>
        {infoRows.map((row) => (
          <InfoRow
            key={row.label}
            allowEdit
            {...row}
            onEditClick={(): void =>
              goToStep(row.editStep, {
                state: { autoFocusField: row.editField },
              })
            }
          />
        ))}
      </InfoList>
    </div>
  );
}
